import { apiRequest } from 'utils/request'
import { API_VERSION_TWO } from 'utils/constants'

export default {
  getVehicleCtp: ({ serialNumber }) => {
    const uri = `/vehicles/${serialNumber}/circuits`
    return apiRequest({ uri })
  },
  getVehicleCtpReport: ({ serialNumber }) => {
    const uri = `/vehicles/${serialNumber}/circuits/report`
    return apiRequest({ uri })
  },
  getVehicleModuleConnector: ({ serialNumber, module, connector }) =>
    apiRequest({
      uri: `/vehicles/${serialNumber}/${module}/${connector}/circuits`,
      version: API_VERSION_TWO,
    }),
  moveCircuit: ({ serialNumber, source, target, circuitNumber, notes }) =>
    apiRequest({
      uri: `/vehicles/${serialNumber}/circuits/update`,
      method: 'POST',
      body: {
        serialNumber,
        source,
        target,
        circuitNumber,
        notes,
      },
    }),
  removeCircuit: ({
    serialNumber,
    module,
    connector,
    pin,
    circuitNumber,
    notes,
  }) =>
    apiRequest({
      uri: `/vehicles/${serialNumber}/circuits/remove`,
      method: 'POST',
      body: {
        serialNumber,
        module,
        connector,
        pin,
        circuitNumber,
        notes,
      },
    }),
}
